import * as React from 'react';

import { StyleSheet, css } from '@coursera/coursera-ui';

import { HEADER_HEIGHT_PX } from 'bundles/authentication/constants';
import CourseraLogo from 'bundles/page/components/CourseraLogo';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

type Props = {
  className?: string;
  logoAsLink?: boolean;
  linkTrackingName?: string;
};

const styles = StyleSheet.create({
  container: {
    alignItem: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    height: `${HEADER_HEIGHT_PX}px`,
    justifyContent: 'center',
    left: '0',
    position: 'fixed',
    top: '0',
    width: '100%',
    zIndex: '1',
  },
  logo: {
    width: '108px',
  },
  logoLink: {
    display: 'flex',
    alignCenter: 'center',
  },
});

const Header = ({ className, logoAsLink, linkTrackingName }: Props) => (
  <header {...css(className, styles.container)}>
    {logoAsLink ? (
      <TrackedA {...css(styles.logoLink)} href="/" trackingName={linkTrackingName || 'auth_modal_logo'}>
        <CourseraLogo {...css(styles.logo)} />
      </TrackedA>
    ) : (
      <CourseraLogo {...css(styles.logo)} />
    )}
  </header>
);

export default Header;
